import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  pageMerchantCertifications, 
  getMerchantCertificationById,
  updateMerchantCertificationStatus
} from '../../api/merchantCertification';
import { message } from 'antd';

// 分页查询商家认证列表的异步 thunk
export const fetchMerchantCertifications = createAsyncThunk(
  'merchantCertification/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await pageMerchantCertifications(params);
      return response.data;
    } catch (error) {
      message.error('获取商家认证列表失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 获取商家认证详情的异步 thunk
export const fetchMerchantCertificationDetail = createAsyncThunk(
  'merchantCertification/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getMerchantCertificationById(id);
      return response.data;
    } catch (error) {
      message.error('获取商家认证详情失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 更新商家认证状态的异步 thunk
export const changeMerchantCertificationStatus = createAsyncThunk(
  'merchantCertification/changeStatus',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateMerchantCertificationStatus(data);
      
      if (response.code === 200) {
        message.success('商家认证状态更新成功');
        // 重新获取列表
        dispatch(fetchMerchantCertifications());
        return response.data;
      } else {
        message.error(response.message || '状态更新失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('状态更新请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

const merchantCertificationSlice = createSlice({
  name: 'merchantCertification',
  initialState: {
    certifications: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentCertification: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentCertification: (state, action) => {
      state.currentCertification = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取列表
      .addCase(fetchMerchantCertifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantCertifications.fulfilled, (state, action) => {
        state.loading = false;
        state.certifications = action.payload.records;
        state.total = action.payload.total;
        state.page = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchMerchantCertifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 获取详情
      .addCase(fetchMerchantCertificationDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantCertificationDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCertification = action.payload;
      })
      .addCase(fetchMerchantCertificationDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 更新状态
      .addCase(changeMerchantCertificationStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeMerchantCertificationStatus.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changeMerchantCertificationStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { 
  setPage, 
  setPageSize, 
  setCurrentCertification 
} = merchantCertificationSlice.actions;

export default merchantCertificationSlice.reducer;
